import { emit } from "@tauri-apps/api/event";

const CHECK_FOR_UPDATE_EVENT = "check-for-update";
const SNOOZED_UNTIL_KEY = "denker.desktop_update_notification.snoozed_until";

let tomorrowTimer: ReturnType<typeof setTimeout> | null = null;
let inMemoryDueAt: number | null = null;

function getLocalStorage(): Storage | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

function persistDueAt(dueAt: number | null): void {
  inMemoryDueAt = dueAt;
  try {
    const storage = getLocalStorage();
    if (dueAt === null) storage?.removeItem(SNOOZED_UNTIL_KEY);
    else storage?.setItem(SNOOZED_UNTIL_KEY, String(dueAt));
  } catch {
    // The in-memory timer still covers the current app session.
  }
}

function armTimer(dueAt: number, now: Date): void {
  if (tomorrowTimer) clearTimeout(tomorrowTimer);
  const delay = Math.max(0, dueAt - now.getTime());

  tomorrowTimer = setTimeout(() => {
    tomorrowTimer = null;
    persistDueAt(null);
    void emit(CHECK_FOR_UPDATE_EVENT).catch(() => undefined);
  }, delay);
}

export function scheduleDesktopUpdateCheckTomorrow(now = new Date()): void {
  const nextDay = new Date(now);
  nextDay.setHours(24, 0, 0, 0);
  const dueAt = nextDay.getTime();

  persistDueAt(dueAt);
  armTimer(dueAt, now);
}

export function armPendingDesktopUpdateCheck(now = new Date()): void {
  let dueAt = inMemoryDueAt;
  try {
    const stored = getLocalStorage()?.getItem(SNOOZED_UNTIL_KEY);
    if (stored) dueAt = Number(stored);
  } catch {
    // Fall back to the in-memory due time.
  }

  if (dueAt === null || !Number.isFinite(dueAt)) return;
  armTimer(dueAt, now);
}

export function clearDesktopUpdateSnooze(): void {
  if (tomorrowTimer) clearTimeout(tomorrowTimer);
  tomorrowTimer = null;
  persistDueAt(null);
}
